export enum TypeResource {
    
}
